
export type DeletionInProgressStatus =
    "No"
    | "SoftDelete"
    | "HardDelete";